import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Card from "../common/components/Card";
import CustomForm from "../common/components/CustomForm";
import DataTable from "../common/components/DataTable";
import { Col, Row } from "../common/components/Grid";
import TextInput from "../common/components/TextInput";
import useClientConfig from "../common/hooks/clientConfigHook";
import LevelDropdown from "./LevelDropdown";
import SiteDropdown from "./SiteDropdown";
import TypeDropdown from "./TypeDropdown";
import PropTypes from 'prop-types';

export const EventDetails = ({event, disabled = false, readonly = false, onChange, handleTypeUpdate, onActiveTimeAdd, onActiveTimeChange, onActiveTimeRemove}) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const activityColumns = useMemo(() => [{field: 'start', editable: true, id: 'startDate', title: t('startDate'), type: 'date', required: true}, {field: 'start', editable: true, id: 'startTime', title: t('startTime'), type: 'time', required: true},
        {field: 'end', id: 'endDate', editable: true, title: t('endDate'), type: 'date', required: true}, {field: 'end', id: 'endTime', editable: true, title: t('endTime'), type: 'time', required: true}], [t])
    const handleUpdate = useCallback(delta => onChange?.(delta), [onChange]);
    return <>
        <Row>
            <Col><TextInput value={event.name} placeholder={t('name')} disabled={disabled} readonly={readonly} onChange={name => handleUpdate({ name })}></TextInput></Col>
        </Row>
        <Row>
            {clientConfig.enableSites ? <Col><SiteDropdown wildcard={t('anyWildcard')} site={event.site} disabled={disabled} readonly={readonly} onChange={handleUpdate}></SiteDropdown></Col> : null }
            {clientConfig.enableLevels ? <Col><LevelDropdown wildcard={t('anyWildcard')} site={event.site} level={event.level} disabled={disabled} readonly={readonly} onChange={handleUpdate}></LevelDropdown></Col> : null}
            <Col><TypeDropdown wildcard={t('anyWildcard')} site={event.site} level={event.level} type={event.type} disabled={disabled} readonly={readonly} onChange={handleTypeUpdate}></TypeDropdown></Col>
        </Row>
        <Card title={t('activeTimes')}>
            <DataTable disabled={disabled} readonly={readonly} columns={activityColumns} defaultSort={['-start']} value={event.active ?? []} onAdd={onActiveTimeAdd} canAdd={row => (new Date(row.start)) < (new Date(row.end))} onRemove={onActiveTimeRemove} onChange={onActiveTimeChange} canUpdate={row => (new Date(row.start)) < (new Date(row.end))}></DataTable>
        </Card>
        { clientConfig.eventCustomFields && <CustomForm disabled={disabled} readonly={readonly} def={clientConfig.eventCustomFields} data={event.customfields} onChange={v => handleUpdate({ customfields: v })}></CustomForm> }
    </>
}
EventDetails.propTypes = {
    event: PropTypes.object,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    onChange: PropTypes.func,
    handleTypeUpdate: PropTypes.func,
    onActiveTimeAdd: PropTypes.func,
    onActiveTimeChange: PropTypes.func,
    onActiveTimeRemove: PropTypes.func
}